import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=3dc0c97f"
import script from "./Licenses.vue?vue&type=script&lang=js"
export * from "./Licenses.vue?vue&type=script&lang=js"
import style0 from "./Licenses.vue?vue&type=style&index=0&id=3dc0c97f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports